import _ from "lodash";
import { v4 as uuid4 } from "uuid";

export const getTableVerticalHeaders = ({
  rows,
  firstColumn,
}: {
  rows: Array<string>;
  firstColumn: string;
}) => {
  return rows.map((row) => {
    return { key: uuid4(), [firstColumn]: row };
  });
};

export const saveTableData = ({
  newValue,
  onSave,
  onUpdate,
}: {
  newValue: any;
  onSave: ({ newValue }: { newValue: any }) => Promise<any> | void;
  onUpdate: ({ message }: { message?: string }) => void;
}) => {
  const saveResult = onSave({
    newValue: newValue.map((row: any) => _.omit(row, "key")),
  });

  if (typeof saveResult?.then === "function") {
    saveResult.then(() => {
      onUpdate({});
    });
  } else {
    onUpdate({});
  }
};
